<form [formGroup]="formGroup">
  <div data-test="observations-registration">
    <div class="flex--column">
      <ng-container *ngIf="showField('mortality')">
        <div class="spacing--padding-top spacing--padding-bottom text--bold" *ngIf="chickAgeInDays">
          <span class="dialog__title">
            {{ 'observations-labels.ageInDays' | translate }} {{ chickAgeInDays }}
          </span>
        </div>
        <div
          class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-half-bottom"
        >
          {{ 'observations-labels.mortality' | translate }}
          <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
        </div>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'observations-labels.mortalityDeath' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="mortalityDeath"
            placeholder="{{ 'observations-labels.mortalityDeath' | translate }}"
            data-test="observations-registration__mortalityDeath"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'observations-labels.mortalityCripple' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="mortalityCripple"
            placeholder="{{ 'observations-labels.mortalityCripple' | translate }}"
            data-test="observations-registration__mortalityCripple"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'observations-labels.mortalitySexError' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="mortalitySexError"
            placeholder="{{ 'observations-labels.mortalitySexError' | translate }}"
            data-test="observations-registration__mortalitySexError"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'observations-labels.mortalitySelection' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="mortalitySelection"
            placeholder="{{ 'observations-labels.mortalitySelection' | translate }}"
            data-test="observations-registration__mortalitySelection"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'observations-labels.mortalityOther' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="mortalityOther"
            placeholder="{{ 'observations-labels.mortalityOther' | translate }}"
            data-test="observations-registration__mortalityOther"
          />
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'observations-labels.mortalityDamages' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="1"
            formControlName="mortalityDamages"
            placeholder="{{ 'observations-labels.mortalityDamages' | translate }}"
            data-test="observations-registration__mortalityDamages"
          />
        </mat-form-field>
        <div
          *ngIf="
            showField('feedName') ||
            showField('feedIntakeInGramsPerAnimal') ||
            showField('waterIntakeInLitersTotal') ||
            showField('numberOfMinutesLight') ||
            showField('lightIntensityInLux')
          "
          class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-half-bottom"
        >
          <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
        </div>
      </ng-container>
      <button
        *ngIf="
          showField('feedName') ||
          showField('feedIntakeInGramsPerAnimal') ||
          showField('waterIntakeInLitersTotal') ||
          showField('numberOfMinutesLight') ||
          showField('lightIntensityInLux')
        "
        mat-flat-button
        type="button"
        class="mat-button"
        data-test="observations-registration__copy-values-button"
        [matTooltip]="'observations-labels.copy-values-tooltip-text' | translate"
        (click)="copyValuesToOtherDaysOfWeek()"
      >
        {{ 'observations-labels.copy-values-for-entire-week-button-text' | translate }}
      </button>
      <mat-form-field class="flex__child--auto" *ngIf="showField('feedName')">
        <mat-label>{{ 'observations-labels.feedName' | translate }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{ 'observations-labels.feedName' | translate }}"
          formControlName="feedName"
          data-test="observations-registration__feedName"
        >
          <mat-option [value]="null">{{ 'none' | translate }}</mat-option>
          <mat-option *ngFor="let feedCode of feedCodes" [value]="feedCode">
            {{ feedCode }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="flex__child--auto" *ngIf="showField('feedIntakeInGramsPerAnimal')">
        <mat-label>{{ 'observations-labels.feedIntakeInGramsPerAnimal' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="feedIntakeInGramsPerAnimal"
          placeholder="{{ 'observations-labels.feedIntakeInGramsPerAnimal' | translate }}"
          data-test="observations-registration__feedIntakeInGramsPerAnimal"
        />
        <span matTextSuffix class="form-field-suffix">g</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('waterIntakeInLitersTotal')">
        <mat-label>{{ 'observations-labels.waterIntakeInLitersTotal' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          inputmode="decimal"
          formControlName="waterIntakeInLitersTotal"
          placeholder="{{ 'observations-labels.waterIntakeInLitersTotal' | translate }}"
          data-test="observations-registration__waterIntakeInLitersTotal"
        />
        <span matTextSuffix class="form-field-suffix">L</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('numberOfMinutesLight')">
        <mat-label>{{ 'observations-labels.numberOfMinutesLight' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="numberOfMinutesLight"
          placeholder="{{ 'observations-labels.numberOfMinutesLight' | translate }}"
          data-test="observations-registration__numberOfMinutesLight"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('lightIntensityInLux')">
        <mat-label>{{ 'observations-labels.lightIntensityInLux' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="lightIntensityInLux"
          placeholder="{{ 'observations-labels.lightIntensityInLux' | translate }}"
          data-test="observations-registration__lightIntensityInLux"
        />
        <span matTextSuffix class="form-field-suffix">lux</span>
      </mat-form-field>
      <div
        *ngIf="
          showField('animalWeightInGrams') ||
          showField('uniformity') ||
          showField('coefficientOfVariation')
        "
        class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-half-bottom"
      >
        <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
      </div>
      <mat-form-field class="flex__child--auto" *ngIf="showField('animalWeightInGrams')">
        <mat-label>{{ 'observations-labels.animalWeightInGrams' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="1"
          inputmode="decimal"
          formControlName="animalWeightInGrams"
          placeholder="{{ 'observations-labels.animalWeightInGrams' | translate }}"
          data-test="observations-registration__animalWeightInGrams"
        />
        <span matTextSuffix class="form-field-suffix">g</span>
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('uniformity')">
        <mat-label>{{ 'observations-labels.uniformity' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.1"
          inputmode="decimal"
          formControlName="uniformity"
          placeholder="{{ 'observations-labels.uniformity' | translate }}"
          data-test="observations-registration__uniformity"
        />
      </mat-form-field>
      <mat-form-field class="flex__child--auto" *ngIf="showField('coefficientOfVariation')">
        <mat-label>{{ 'observations-labels.coefficientOfVariation' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.1"
          inputmode="decimal"
          formControlName="coefficientOfVariation"
          placeholder="{{ 'observations-labels.coefficientOfVariation' | translate }}"
          data-test="observations-registration__coefficientOfVariation"
        />
      </mat-form-field>
      <div
        *ngIf="showField('notes')"
        class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-half-bottom"
      >
        <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
      </div>
      <mat-form-field class="flex__child--auto" *ngIf="showField('notes')">
        <mat-label>{{ 'observations-labels.notes' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="notes"
          rows="4"
          placeholder="{{ 'observations-labels.notes' | translate }}"
          data-test="observations-registration__notes"
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</form>
